import React from 'react';
import styled from 'styled-components';
import Slideshow from '../components/Slideshow';
import NewspaperWrapper from '../components/NewspaperWrapper';

// Page container with site background
const Container = styled.div`
  background-color: #fff; /* match site background */
  min-height: calc(100vh - 140px); /* leave space for header + subheader */
  padding: 24px 40px 40px; /* reduce top padding to tighten title spacing */
  position: relative;
  z-index: 0; /* make sure content sits above any stray overlays */
  margin-top: 0;

  @media (max-width: 768px) {
    padding: 16px;
    min-height: calc(100vh - 120px);
  }
`;


const Section = styled.section`
  margin: 0;
  max-width: 1400px;
`;

// Use script font like header logo

/* Removed grid/card styles in favor of slideshow */

const Description = styled.p`
  margin: 24px 4px 0;
  color: #1a1a1a;
  line-height: 1.7;
  font-size: 1.05rem;
  font-family: 'Georgia', 'Times New Roman', serif;
  text-align: justify;
  padding: 0 8px;

  @media (max-width: 768px) {
    font-size: 0.95rem;
    line-height: 1.6;
    margin-top: 20px;
    text-align: left;
  }
`;

const PUB = process.env.PUBLIC_URL || '';

/* Lightbox styles removed; using Slideshow controls */

// Removed MediaCard; slideshow presents one image at a time

const sections = [
  {
    title: 'The Staples Collection',
    subtitle: 'FW’25 everyday ready to wear',
    volume: 'VOL. I, No. 2',
    date: '26 NOV 2025',
    description: 'Explore our latest FW’25 staples collection, an assortment of unbranded staple everyday ready to wear tanks, tees, pullover and zip up hoodies, as well as two different styles of pant - Flared and Cuffed. Available in a variety of colors ranging from white, chalk, to navy and black. Made up of French terry cotton, they are the best pieces around, no short cuts.',
    images: [
      `${PUB}/assets/Hometest.jpg`,
      `${PUB}/assets/_DSC3555.jpg`,
      `${PUB}/assets/_DSC3568.jpg`,
    ],
  },
  {
    title: 'Sprezzatura Staples',
    subtitle: 'Drawing inspiration from the 1900s',
    volume: 'VOL. I, No. 1',
    date: '26 NOV 2025',
    description: "Drawing inspiration from the 1900s, we've created an advertisement to commemorate the release of the collection. In addition we've designed an illustrative magazine further detailing the product.",
    images: [
      `${PUB}/assets/MagCover1.jpg`,
      `${PUB}/assets/ZipUpAd.jpg`,
      `${PUB}/assets/TShirtAd1.jpg`,
      `${PUB}/assets/FlaredSweat.jpg`,
      `${PUB}/assets/NewAD_.jpg`,
      `${PUB}/assets/BeaterAd.jpg`,
      `${PUB}/assets/BeaterAd2.jpg`,
      `${PUB}/assets/JoggerAD.jpg`,
    ],
  },
];

const Media = () => {
  return (
    <Container aria-label="Media Page">
      {sections.map((sec) => (
        <Section key={sec.title}>
          <NewspaperWrapper
            title={sec.title}
            subtitle={sec.subtitle}
            volume={sec.volume}
            date={sec.date}
          >
            <Slideshow images={sec.images} ariaLabelPrefix={sec.title} />
            <Description>{sec.description}</Description>
          </NewspaperWrapper>
        </Section>
      ))}
    </Container>
  );
};

export default Media;
